import {EntityService} from '../../service/EntityService';

export class DashboardService extends EntityService {
  static entity = '/iam-system/dashboard';

  static getDashboarhAmount(fromDate: any, thruDate: any): Promise<any> {
    return this.axios.get(`${this.entity}/amount-total?fromDate=${fromDate}&thruDate=${thruDate}`).then(res => res.data);
  }

  static getDashboarhAsset(): Promise<any> {
    return this.axios.get(`${this.entity}/used-asset`).then(res => res.data);
  }

  static getIssuedQuantityPeriod(lastNMonth: any): Promise<any> {
    return this.axios.get(`${this.entity}/issued-quantity-period?lastNMonth=${lastNMonth}`).then(res => res.data);
  }

  static getIssuedAndRemain(fromDate: any, thruDate: any): Promise<any> {
    return this.axios.get(`${this.entity}/issued-remain-quantity?fromDate=${fromDate}&thruDate=${thruDate}`).then(res => res.data);
  }
  static getStatusQuantity(): Promise<any> {
    return this.axios.get(`${this.entity}/status-agreement-quantity`).then(res => res.data);
  }

  static getOverviewStatistics(totalLastNMonth?: number, signedLastNMonth?: number, pendingLastNMonth?: number, draftLastNMonth?: number): Promise<any> {
    const params = new URLSearchParams();
    if (totalLastNMonth) params.append('totalLastNMonth', totalLastNMonth.toString());
    if (signedLastNMonth) params.append('signedLastNMonth', signedLastNMonth.toString());
    if (pendingLastNMonth) params.append('pendingLastNMonth', pendingLastNMonth.toString());
    if (draftLastNMonth) params.append('draftLastNMonth', draftLastNMonth.toString());
    return this.axios.get(`${this.entity}/overview-statistics?${params.toString()}`).then(res => res.data);
  }
}